module.exports = __webpack_public_path__ + "static/media/SOFT TISSUE 10.1c4b014c.jpg";